/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Scope_PartnerInputs */

const vi_api_keys_scope_partner = /** @type {(inputs: Api_Keys_Scope_PartnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đối tác (partner)`)
};

/**

* @param {Api_Keys_Scope_PartnerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_scope_partner = /** @type {((inputs?: Api_Keys_Scope_PartnerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Scope_PartnerInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_scope_partner(inputs)
});